import { Alert, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface PdfPagesNotReadyAlertProps {
  onRetry: () => void;
  isRetrying: boolean;
}

// The new photo is kept by the caller: retrying resends exactly what the user picked.
export function PdfPagesNotReadyAlert({ onRetry, isRetrying }: PdfPagesNotReadyAlertProps) {
  const { t } = useTranslation('goodsReceiving');
  return (
    <Alert
      severity="warning"
      action={
        <Button
          color="inherit"
          size="small"
          onClick={onRetry}
          disabled={isRetrying}
          sx={{ minHeight: 48 }}
        >
          {t('pdfPagesNotReadyRetry')}
        </Button>
      }
    >
      {t('pdfPagesNotReady')}
    </Alert>
  );
}
